import React from 'react';
import Button from '@material-ui/core/Button';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import '../../assets/style/detailSection.scss';

// The one button style for section headers and footers: small, outlined,
// short label with a leading icon. `quiet` = text-only for secondary links
// (placed at the start of a footer row); `primary` = filled, for the main
// action of a page.
export function SectionButton({
  icon: Icon, children, onClick, disabled, quiet, primary,
}) {
  let variant = 'outlined';
  if (quiet) variant = 'text';
  if (primary) variant = 'contained';
  return (
    <Button
      className={`ds-btn ${quiet ? 'ds-btn-quiet' : ''}`}
      variant={variant}
      disableElevation={primary}
      color='primary'
      size='small'
      disabled={disabled}
      startIcon={Icon ? <Icon /> : null}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}

// Collapsible card for one section of a detail page: header with a
// collapse toggle, optional section icon, title and optional action
// buttons; body shown when open.
export function DetailSection({
  title, icon: Icon, open, onToggle, actions, children,
}) {
  return (
    <section className='ds-card'>
      <header className={`ds-head ${open ? '' : 'collapsed'}`}>
        <button type='button' className='ds-toggle' aria-expanded={open} onClick={onToggle}>
          <ExpandMoreRoundedIcon className='ds-chevron' />
          {Icon ? <span className='ds-icon' aria-hidden='true'><Icon /></span> : null}
          <h2>{title}</h2>
        </button>
        {actions ? <div className='ds-actions'>{actions}</div> : null}
      </header>
      {open && children ? <div className='ds-body'>{children}</div> : null}
    </section>
  );
}

// Grid of label / value pairs.
export function FieldGrid({ children }) {
  return <dl className='ds-fields'>{children}</dl>;
}

export function Field({ label, children, wide }) {
  return (
    <div className={`ds-field ${wide ? 'wide' : ''}`}>
      <dt>{label}</dt>
      <dd>{children}</dd>
    </div>
  );
}

// Buttons under a table inside a section.
export function SectionFooter({ children }) {
  return <div className='ds-footer'>{children}</div>;
}

// Placeholder for a detail page while its data loads: a title bar and
// section cards (fields or table rows) in the page's own layout, so the
// real content replaces it in place instead of flashing an overlay.
export function DetailPageSkeleton({ sections = ['fields', 'fields', 'table', 'table'] }) {
  return (
    <div className='ds-skeleton' aria-busy='true' aria-label='Loading'>
      <div className='ds-title'>
        <span className='ds-sk ds-sk-h1' />
        <span className='ds-sk ds-sk-sub' />
      </div>
      {sections.map((kind, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <section className='ds-card' key={i}>
          <header className='ds-head'>
            <span className='ds-sk ds-sk-icon' />
            <span className='ds-sk ds-sk-h2' />
          </header>
          <div className='ds-body'>
            {kind === 'fields' ? (
              <div className='ds-fields'>
                {[0, 1, 2, 3, 4, 5].map((f) => (
                  <div className='ds-field' key={f}>
                    <span className='ds-sk ds-sk-label' />
                    <span className='ds-sk ds-sk-value' />
                  </div>
                ))}
              </div>
            ) : (
              <div className='ds-sk-table'>
                {[0, 1, 2, 3].map((r) => <span className='ds-sk ds-sk-row' key={r} />)}
              </div>
            )}
          </div>
        </section>
      ))}
    </div>
  );
}
